import { format as formatDate, formatDistanceStrict } from 'date-fns';
const DATE_PATTERN = 'MMM d, yyyy';
const DATE_TIME_PATTERN = 'MMM d, yyyy p';
export function renderDate(param) {
    let { value, format, now } = param;
    if (format === 'timeAgo' && now != null) {
        return formatDistanceStrict(value, now, {
            addSuffix: true
        });
    }
    return formatDate(value, format === 'dateTime' ? DATE_TIME_PATTERN : DATE_PATTERN);
}
